import { LiveSearchResultsGridComponent } from './component/LiveSearchResultsGridComponent';
import { WEB_COMPONENT_LIVE_SEARCH_RESULTS_GRID } from '../../../webcomponents.constants';

export { LiveSearchResultsGridComponent };

window.customElements.define(WEB_COMPONENT_LIVE_SEARCH_RESULTS_GRID, LiveSearchResultsGridComponent);
